function redrawSnippetItem(payload,i, htmlSnippet)
{
    var objectSnippet = $(htmlSnippet);
    var redrawWholeComponent = true;

    if(typeof payload.redrawBlocks !== 'undefined' && typeof payload.redrawBlocks[i] !== 'undefined' && payload.redrawBlocks[i].length) {
        redrawWholeComponent = false;

        for (let iBlock in payload.redrawBlocks[i]) {

            var idToFind = payload.redrawBlocks[i][iBlock].block;
            var insertType = payload.redrawBlocks[i][iBlock].insertType;

            if(objectSnippet.is("#" + idToFind)) {
                var htmlToReplace = objectSnippet;
            } else {
                var htmlToReplace = objectSnippet.find("#" + idToFind);
            }

            if(!htmlToReplace.length) {
                continue;
            }

            switch(insertType) {
                case 'default':
                    $("#" + idToFind).replaceWith(htmlToReplace);
                    break;
                case 'append':

                    if(htmlToReplace.length) {
                        htmlToReplace = htmlToReplace.html();
                        $("#" + idToFind).append(htmlToReplace);
                    }
                    break;
            }
        }
    }

    if(redrawWholeComponent) {
        var snippetItem = $(htmlSnippet);
        if(snippetItem.is('#' + i)) {
            $("#" + i).replaceWith(snippetItem);
        } else {
            var snippet = snippetItem.find("#" + i);
            $("#" + i).replaceWith(snippet);
        }
    }
}

function fn_ajax_handler(payload, callback) {
    if (payload) {
        // přesměrování "this" přesměruje na aktuální stránku
        if (payload.redirect) {
            if (payload.redirect === 'this') {
                location.href = window.location.href.split("#")[0];
            } else {
                location.href = payload.redirect;
            }
        }

        // výměna snippetů v šabloně - každý snippet musí mít unikátní ID
        if (payload.snippets) {
            for (let i in payload.snippets) {

                if(typeof payload.snippets[i] === 'object') {
                    for (let iSnippet in payload.snippets[i]) {
                        redrawSnippetItem(payload, i, payload.snippets[i][iSnippet]);
                    }
                } else {
                    redrawSnippetItem(payload, i, payload.snippets[i]);
                }
            }
        }

        // výměna adresy v adresním řádku
        if (payload.replaceState) {
            window.history.replaceState(null, payload.replaceState.title || null, payload.replaceState.url);

            if (payload.replaceState.title) {
                document.title = payload.replaceState.title;
            }
        }

        // pridani do historie prohlizece
        if (payload.pushState) {
            if (window.location.pathname != payload.pushState.url) {
                window.history.pushState(null, payload.pushState.title || null, payload.pushState.url);

                if (payload.pushState.title) {
                    document.title = payload.pushState.title;
                }
            }
        }

        if (callback) {
            callback();
        }
    }
}

window.onpopstate = function (event) {
    $('#layout_site_nav').find('.ajax_site[href="' + window.location.pathname + '"]').click();
};